// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableModalContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tableModalImageContainer {
  height: 160px;
  width: 230px;
}

.tableModalTableName {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 10px 0px 0px 0px;
}

.tableModalActionButton {
  width: 100%;
  display: flex;
  gap: 8px;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/table-layout/components/TableDetailsModal/TableDetailsModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,QAAQ;EACR,eAAe;AACjB","sourcesContent":[".tableModalContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.tableModalImageContainer {\n  height: 160px;\n  width: 230px;\n}\n\n.tableModalTableName {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 10px 0px 0px 0px;\n}\n\n.tableModalActionButton {\n  width: 100%;\n  display: flex;\n  gap: 8px;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
